import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface ColorPickerContextType {
  openPickerId: string | null;
  openColorPicker: (pickerId: string) => void;
  closeColorPicker: (pickerId: string) => void;
  isOpen: (pickerId: string) => boolean;
}

const ColorPickerContext = createContext<ColorPickerContextType | undefined>(undefined);

export const ColorPickerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openPickerId, setOpenPickerId] = useState<string | null>(null);

  const openColorPicker = useCallback((pickerId: string) => {
    setOpenPickerId(pickerId);
  }, []);

  const closeColorPicker = useCallback((pickerId: string) => {
    setOpenPickerId((current) => (current === pickerId ? null : current));
  }, []);

  const isOpen = useCallback(
    (pickerId: string) => {
      return openPickerId === pickerId;
    },
    [openPickerId]
  );

  return (
    <ColorPickerContext.Provider value={{ openPickerId, openColorPicker, closeColorPicker, isOpen }}>
      {children}
    </ColorPickerContext.Provider>
  );
};

export const useColorPickerContext = () => {
  const context = useContext(ColorPickerContext);
  if (!context) {
    throw new Error("useColorPickerContext must be used within a ColorPickerProvider");
  }
  return context;
};
